// JS - custom-carousel.js
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-id]').forEach(carousel => {
        const items = Array.from(carousel.querySelectorAll('.carousel-item'));

        items.forEach(item => {
            const clone = item.cloneNode(true);
            carousel.appendChild(clone);
        });

        let isDragging = false;
        let startX = 0;
        let scrollStart = 0;

        const checkAndClone = () => {
            const maxScroll = carousel.scrollWidth - carousel.clientWidth;
            if (carousel.scrollLeft >= maxScroll - 100) {
                items.forEach(item => {
                    const clone = item.cloneNode(true);
                    carousel.appendChild(clone);
                });
            }
        };

        carousel.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.pageX;
            scrollStart = carousel.scrollLeft;
        });

        carousel.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            requestAnimationFrame(() => {
                const diff = startX - e.pageX;
                carousel.scrollLeft = scrollStart + diff;
                checkAndClone();
            });
        });

        carousel.addEventListener('scroll', checkAndClone);

        carousel.addEventListener('mouseup', () => {
            isDragging = false;
        });

        carousel.addEventListener('mouseleave', () => {
            isDragging = false;
        });
    });
});